import { useWizard } from '../context/WizardContext';
import { motion } from 'framer-motion';

export const StepIndicator = () => {
  const { step, totalSteps } = useWizard();

  return (
    <div className="flex items-center justify-center gap-2 mb-8">
      {Array.from({ length: totalSteps }, (_, i) => i + 1).map((s) => (
        <div key={s} className="flex items-center">
          <motion.div
            className={`w-3 h-3 rounded-full transition-colors duration-300 ${
              s === step
                ? 'bg-[#C9A24A] scale-125'
                : s < step
                ? 'bg-[#C9A24A]/60'
                : 'bg-white/20'
            }`}
            initial={{ scale: 0.8 }}
            animate={{ scale: s === step ? 1.25 : 1 }}
            transition={{ duration: 0.3 }}
          />
          {s < totalSteps && (
            <div
              className={`w-12 h-0.5 transition-colors duration-300 ${
                s < step ? 'bg-[#C9A24A]/60' : 'bg-white/10'
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
};

const stepTitles = [
  'Destino e Objetivo',
  'Seu Perfil',
  'Seus Dados'
];

export const StepTitle = () => {
  const { step, totalSteps } = useWizard();

  return (
    <motion.div
      key={step}
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 10 }}
      className="text-center mb-6"
    >
      <span className="text-[#C9A24A] text-sm uppercase tracking-widest">
        Etapa {step} de {totalSteps}
      </span>
      <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl text-white mt-2">
        {stepTitles[step - 1]}
      </h2>
    </motion.div>
  );
};

export default StepIndicator;
